/**
 * https://github.com/calibreapp/react-live-chat-loader/tree/main
 * https://developer.chrome.com/docs/lighthouse/performance/third-party-facades/?utm_source=lighthouse&utm_medium=devtools
 * https://wavesaudio.atlassian.net/browse/DSWEB-4416
 */
import { LiveChatLoaderProvider } from 'react-live-chat-loader';
import { IntercomBtn } from './intercom-btn';
import ReactDOM from 'react-dom';
import React from 'react';

interface IIntercomLazyLoad {
    providerKey: string;
}

export const IntercomLazyLoad = ({ providerKey }: IIntercomLazyLoad) => {
    return (
        <LiveChatLoaderProvider
            providerKey={ providerKey }
            provider="intercom">
            <IntercomBtn key={ providerKey } />
        </LiveChatLoaderProvider>
    )
};


export const initIntercom = () => {
    const $root = document.getElementById('intercom-ph');
    if(!$root) return;

    const providerKey = $root.getAttribute('data-key') || '';
    if(!providerKey) return;

    ReactDOM.render(
        <React.StrictMode>
            <IntercomLazyLoad providerKey={ providerKey } />
        </React.StrictMode>,
        $root
    );
};

// ----------------------- INITIAL SCRIPT ----------------------
/*
<!-- Intercom Chat -->
@if (@ViewBag.LayoutModel.IsUserAuthenticated)
{
    <script>
        window.intercomSettings = {
            api_base: "https://api-iam.intercom.io",
            app_id: "@ViewBag.LayoutModel.IntercomAppID",
            name: "@ViewBag.LayoutModel.User.FullName.Replace("'", "")",
            email: "@ViewBag.LayoutModel.User.Email",
            WavesClientID: "@(ViewBag.LayoutModel.User.GetValue("WavesClientID"))"
        };
    </script>
}
else
{
    <script>
        window.intercomSettings = {
            api_base: "https://api-iam.intercom.io",
            app_id: "@ViewBag.LayoutModel.IntercomAppID",
        };
    </script>
}

<script>
    // We pre-filled your app ID in the widget URL: 'https://widget.intercom.io/widget/@ViewBag.LayoutModel.IntercomAppID'
    (function () { var w = window; var ic = w.Intercom; if (typeof ic === "function") { ic('reattach_activator'); ic('update', w.intercomSettings); } else { var d = document; var i = function () { i.c(arguments); }; i.q = []; i.c = function (args) { i.q.push(args); }; w.Intercom = i; var l = function () { var s = d.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://widget.intercom.io/widget/@(ViewBag.LayoutModel.IntercomAppID)'; var x = d.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); }; if (document.readyState === 'complete') { l(); } else if (w.attachEvent) { w.attachEvent('onload', l); } else { w.addEventListener('load', l, false); } } })();
</script>

 */